import { Response } from 'src/types';

import { apiRequest } from '../api';
import { endpoints } from '../config';
import { RequestMethodEnum } from '../types';
import {
  AddInteractionDictionaryRequest,
  AddInteractionDictionaryResponse,
  InteractionDictionary,
} from './types';

export const getInteractionsDictionary = async (): Promise<
  InteractionDictionary[]
> => {
  const response = await apiRequest<Response<InteractionDictionary[]>, void>(
    endpoints.interactionsDictionary.getAll,
    RequestMethodEnum.GET,
    {}
  );
  return response?.data || [];
};

export const getInteractionDictionary = async (
  id: number
): Promise<InteractionDictionary | undefined> => {
  const response = await apiRequest<Response<InteractionDictionary>, void>(
    endpoints.interactionsDictionary.getDetails(id),
    RequestMethodEnum.GET,
    {}
  );
  return response?.data;
};

export const addInteractionDictionary = async (
  data: AddInteractionDictionaryRequest
): Promise<AddInteractionDictionaryResponse | undefined> => {
  const response = await apiRequest<
    Response<AddInteractionDictionaryResponse>,
    AddInteractionDictionaryRequest
  >(endpoints.interactionsDictionary.add, RequestMethodEnum.POST, {
    data,
    showErrorMessage: true,
    showSuccessMessage: true,
  });
  return response?.data;
};

export const editInteractionDictionary = async (
  id: number,
  formData: FormData
): Promise<InteractionDictionary | undefined> => {
  const response = await apiRequest<Response<InteractionDictionary>, FormData>(
    endpoints.interactionsDictionary.update(id),
    RequestMethodEnum.PATCH,
    { formData, showErrorMessage: true, showSuccessMessage: true }
  );
  return response?.data;
};

export const deleteInteractionDictionary = async (
  id: number
): Promise<{ id: number } | undefined> => {
  const response = await apiRequest<Response<{ id: number }>, void>(
    endpoints.interactionsDictionary.delete(id),
    RequestMethodEnum.DELETE,
    {
      showErrorMessage: true,
      showSuccessMessage: true,
    }
  );
  return response?.data;
};
